// extracted by mini-css-extract-plugin
export default {"wrapper":"candidates-share_wrapper__iuDgF","card":"candidates-share_card__T9qQd","cardScore":"candidates-share_cardScore__zF0XB","cardInfo":"candidates-share_cardInfo__Oxp0e"};